import React, { FC } from 'react';

import type { IWizardStep } from '../models';
import { Box } from '@src/atoms/Box';
import { Text } from '@src/atoms/Text';
import { Icon } from '@src/atoms/Icon';
import { IClassNameProps, ILoadingProps, IStylesProps } from '@src/models/props';
import { getClass } from '@src/utils/getClass';
import { classnames } from '@src/utils/classnames';

import styled from './WizardHeadItem.scss';

export type TWizardHeadItemView = 'passed' | 'current' | 'inactive';
interface IWizardHeadItemProps extends IClassNameProps, IStylesProps, ILoadingProps {
  step: IWizardStep;
  view: TWizardHeadItemView;
  stepNum: number;
  selectCurrentStep: (idx: number) => void;
  currentIdx: number;
}

export const WizardHeadItem: FC<IWizardHeadItemProps> = ({ step, view, stepNum, selectCurrentStep, currentIdx }) => {
  const classes = classnames(styled.root, getClass(styled, 'view', view), {
    [styled.root_notFirst]: stepNum !== 1,
  });

  const handleReturnToStepBack = () => {
    if (currentIdx > stepNum - 1) {
      selectCurrentStep(stepNum - 1);
    }
  };

  return (
    <Box key={step.id} className={classes} column>
      <Text
        id={'stepNum'}
        className={styled.circle}
        size={'secondary'}
        weight={'bold'}
        onClick={handleReturnToStepBack}
      >
        {view === 'passed' ? <Icon name={'success'} /> : stepNum}
      </Text>
      <Text id={'stepLabel'} size={'secondary'} className={styled.label}>
        {step.label}
      </Text>
    </Box>
  );
};
